export enum LanguageTypeEnum {
	VietNam = 'vi',
	Korea = 'ko',
	English = 'en',
}
